import { render, staticRenderFns } from "./Galaxy.vue?vue&type=template&id=65970b2e&scoped=true&"
import script from "./Galaxy.vue?vue&type=script&lang=js&"
export * from "./Galaxy.vue?vue&type=script&lang=js&"
import style0 from "./Galaxy.vue?vue&type=style&index=0&id=65970b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65970b2e",
  null
  
)

export default component.exports